import React, { FC } from 'react';
import { Box } from '@mui/material';
import StyledBox from './MobileAppExclusiveDealSection.styles';
import {
  Typography700,
  ImgBox,
} from 'views/rebranded-module/common/components';
import NavigatorLink from 'views/rebranded-module/common/components/Logical/NavigatorLink';
import PATHS from 'lib/navigation/paths';
import { useContent } from 'views/rebranded-module/common/context/useContent';

const MobileAppExclusiveDealSection: FC = () => {
  const content = useContent('DealDetailsPage');
  const appleStore = {
    src: '/imgs/appAD/AppStore.png',
    alt : content.downloadOnAppStoreAlt,
  };
  const googlePlay = {
    src: '/imgs/appAD/GooglePlay.png',
    alt: content.getItOnGooglePlayAlt,
  };
  const QRCode = {
    src: '/imgs/appAD/QRCode.png',
   alt: content.qrCodeAlt,
  };

  return (
    <StyledBox>
      <Box className="MEDSInfo">
        <Typography700 variant="h7" component="p">
          {content.dealAvailbleMobilyOnlyTitle}
        </Typography700>
        <Box className="MADSStoreLinks">
          <NavigatorLink href={PATHS.app.ios} className="MADSStoreLink">
            <ImgBox
              image={appleStore}
              imgWidth="100%"
              imgHeight="100%"
              imgObjectFit="contain"
            />
          </NavigatorLink>
          <NavigatorLink href={PATHS.app.android} className="MADSStoreLink">
            <ImgBox
              image={googlePlay}
              imgWidth="100%"
              imgHeight="100%"
              imgObjectFit="contain"
            />
          </NavigatorLink>
        </Box>
      </Box>
      <Box className="MEDSQrImgContainer">
        <Box className="MEDSQrImg">
          <ImgBox
            image={QRCode}
            imgWidth="100%"
            imgHeight="100%"
            imgObjectFit="contain"
          />
        </Box>
      </Box>
    </StyledBox>
  );
};

export { MobileAppExclusiveDealSection };
